// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2pcTe","header":"ReportDetails_header___VWqF","title":"ReportDetails_title__3Fuzh","left":"ReportDetails_left__3pYJy"};